import { NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InteractionStatus, MsalBroadcastService } from '@groundworks/ngx-groundworks-auth';
import { filter, Subject, takeUntil } from 'rxjs';
import { IBranchDto } from '../sdk/sdk';
import { ConfigService } from '../services/config.service';
import { ProfileService } from '../services/profile.service';
import { BranchService } from './services/branch.service';
import { DefaultBranchService } from './services/default-branch.service';

@Component({
  selector: 'app-calendar-shell',
  imports: [RouterOutlet, NgIf],
  templateUrl: './calendar-shell.component.html',
  standalone: true
})
export class CalendarShellComponent implements OnInit {
  title = 'calendar-client';
  whoami = '';
  selectedBranch: string | null | undefined = '';
  defaultBranchSet = true;
  homeUrl: string | null = null;

  private readonly _destroying$ = new Subject<void>();
  public readonly configService = inject(ConfigService);
  private readonly branchService = inject(BranchService);
  private readonly profileService = inject(ProfileService);
  private readonly defaultBranchService = inject(DefaultBranchService);

  constructor(
    private readonly msalBroadcastService: MsalBroadcastService
  ) {
  }

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
        this.setDefaultOfficeLocation();
      });

    this.profileService.whoami$.subscribe(name => {
      this.whoami = name;
    });

    this.homeUrl = this.configService.homeUrl;
  }

  checkAndSetActiveAccount() {
    this.branchService.getSelectedBranch().subscribe({
      next: (branch: IBranchDto | null): void => {
        if (!branch) return;
        this.selectedBranch = `${branch.brand?.shortName}, ${branch.name}`;
      },
      error: (error) => {
        console.error('Error fetching branch:', error);
        this.selectedBranch = '';
      },
    });
  }

  async setDefaultOfficeLocation() {
    if (this.branchService.getCurrentBranch()) {
      this.defaultBranchService.notifyDefaultBranchSet();
      return;
    }

    const token = await this.profileService.getAccountAccessToken();
    const profileResponse = await this.profileService.getProfile(token);
    const locationName = profileResponse.officeLocation;
    let branchDtos: IBranchDto[];

    this.branchService.getBranches().subscribe({
      next: (branches) => {
        branchDtos = branches.filter((b) => b.name === locationName);
        if (branchDtos.length === 1) {
          this.branchService.setSelectedBranch(branchDtos[0]);
          this.defaultBranchService.notifyDefaultBranchSet();
        }
      },
    });
  }

  logout(): void {
    this.profileService.logout();
  }
}
